import React, { useEffect } from "react";

function useDocumentTitle(title) {
  useEffect(() => {
    document.title = `${title} - Site canin`;
  }, [title]);
}

export default useDocumentTitle;
